// src/components/NosotrosSection.js
import React from "react";
import "./NosotrosSection.css";
import logo from "../assets/logo.png";
import omhausImage from "../assets/OmHaus_LOGO.png";

const NosotrosSection = () => {
  return (
    <section className="nosotros-section">
      {/* Title Section */}
      <div className="nosotros-title-container">
        <h2 className="nosotros-title">Nosotros</h2>
      </div>

      <div className="nosotros-divider"></div>

      {/* Content Section */}
      <div className="nosotros-content">
        <div className="nosotros-left">
          <div className="company-image-container">
            <img src={omhausImage} alt="omHaus" className="company-image" />
          </div>
          <p className="company-text">
            iHomes es una empresa actual, valenciada, especializada en el
            desarrollo de proyectos inmobiliarios residenciales de alto valor
            añadido para la sociedad. iHomes aúna la experiencia de más de 20
            años y el knowhow de un equipo profesional, para ofrecer viviendas
            de alta calidad arquitectónica y espacios pensados para vivir.
          </p>
        </div>

        <div className="nosotros-right">
          <div className="logo-container">
            <img src={logo} alt="Logo" className="nosotros-logo" />
          </div>
          <p className="company-text">
            Compañía de Inversión y Desarrollo es una promotora que estructura y
            opera proyectos de real estate que mejoran la calidad de vida y del
            trabajo de las personas, con responsabilidad, creatividad e
            innovación. Cuenta con un equipo de profesionales que integran
            disciplinas como Arquitectura, Ingeniería Civil, Administración,
            Contabilidad, Diseño y Comercialización, aportando la experiencia de
            haber participado en el desarrollo, comercialización y construcción
            de más de 30 proyectos en la región durante los últimos 20 años.
          </p>
        </div>
      </div>
    </section>
  );
};

export default NosotrosSection;
